import { unescape } from "lodash";

function getEscapePlaceHolders(template) {
  const regex = /&lt;%=\s*\w+\s*%&gt;/gi;
  const results = [];
  let result;

  // tslint:disable-next-line: no-conditional-assignment
  while ((result = regex.exec(template))) {
    if (result && Array.isArray(result) && result[0]) {
      results.push(result[0].trim());
    }
  }

  return results;
}

export default function formatEscape(emailTemplate) {
  const placeHolders = getEscapePlaceHolders(emailTemplate);
  if (!placeHolders.length) {
    return emailTemplate;
  }

  let escapeFreeTemplate = emailTemplate;
  placeHolders.forEach((placeHolder) => {
    const toBeReplacedPlaceHolder = placeHolder
      .replace("&lt;", "<")
      .replace("&gt;", ">");
    escapeFreeTemplate = escapeFreeTemplate.replace(
      placeHolder,
      toBeReplacedPlaceHolder
    );
  });

  return escapeFreeTemplate;
}

export const hasTemplateHtmlContent = (htmlString) => {
  if (!htmlString || typeof htmlString !== "string") {
    return false;
  }
  const textOnly = htmlString
    .replace(/<\/?[a-zA-Z][^>]*>/g, "")
    .replace(/\s+/g, "");
  const hasPlaceholders = /<%[=-][\s\S]*?%>|\{\{[\s\S]*?\}\}/.test(htmlString);
  return (
    textOnly.length > 0 ||
    hasPlaceholders ||
    htmlString.toLowerCase().includes("<img")
  );
};

/**
 * Clean up stored html string for rendering / save.
 * @param {*} htmlString
 * @param {*} alt fallback when empty (default "")
 * @param {{ rejectEmpty?: boolean }} options when rejectEmpty, throws instead of returning alt
 * @returns
 */
export const cleanUpHtmlStringForTemplate = (
  htmlString,
  alt = "",
  options = {}
) => {
  const { rejectEmpty = false } = options;
  if (hasTemplateHtmlContent(htmlString)) {
    return unescapedHtmlString(htmlString);
  }
  if (rejectEmpty) {
    throw new Error(
      "EMAIL template error! Template HTML has no visible content. Save was blocked to prevent blank emails."
    );
  }
  return alt;
};

export const unescapedHtmlString = (htmlString = "") => {
  return unescape(htmlString);
  // return htmlString;
};
